import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UsersIDRequestModel } from "../models/UserModels/UsersIDRequestModel";
import { LookupGroupModel } from "../models/Lookups/LookupGroupModel";
import { RequestHandlerService,AuthService, RequestOptionsModel } from "bbsf-utilities";



@Injectable({
  providedIn: 'root'
})
export class LookupGroupsService {
  ApiUrl = "/api/admin/LookupGroup/"
  constructor(private http: RequestHandlerService) {
  }

  AddLookupGroup( AddModel: LookupGroupModel) {
    
    return this.http.post( this.ApiUrl + 'AddLookupGroup', AddModel);
  }

  EditLookupGroup(EditModel: LookupGroupModel) {
    return this.http.post( this.ApiUrl + 'EditLookupGroup', EditModel);
  }

  DeleteLookupGroup( UsersIDRequestModel: UsersIDRequestModel) {
   
    return this.http.post( this.ApiUrl + 'DeleteLookupGroup', UsersIDRequestModel);
  }

}